<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping Registration</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="step-info-wrapper">
                    <div class="container">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li class="on">
                                <span>STEP2.이미지 매핑</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP3. 이미지 크롭</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 4)">
                                <span>STEP4.막장 사진대지</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 5)">
                                <span>STEP5.강도정보</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->
                <!-- gnb -->
                <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
                <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
                <!-- // gnb -->

                <div class="image-edit-wrapper" :class="navClose">
                    <div class="nav-side-box">
                        <ul>
                            <li :class="dataType == 'base' ? 'on' : ''">
                                <button type="button" class="btn nav-image-1" @click="dataArea('base')">
                                    <span class="blind">기본</span>
                                </button>
                            </li>
                            <li :class="dataType == 'rockType' ? 'on' : ''">
                                <button type="button" class="btn nav-image-5" @click="dataArea('rockType')">
                                    <span class="blind">암질</span>
                                </button>
                            </li>
                            <li :class="dataType == 'jointCondition' ? 'on' : ''">
                                <button type="button" class="btn nav-image-2" @click="dataArea('jointCondition')">
                                    <span class="blind">절리상태</span>
                                </button>
                            </li>
                            <li :class="dataType == 'joint' ? 'on' : ''">
                                <button type="button" class="btn nav-image-3" @click="dataArea('joint')">
                                    <span class="blind">절리</span>
                                </button>
                            </li>
                            <li :class="dataType == 'underWater' ? 'on' : ''">
                                <button type="button" class="btn nav-image-4" @click="dataArea('underWater')">
                                    <span class="blind">지하수</span>
                                </button>
                            </li>
                            <li :class="dataType == 'description' ? 'on' : ''">
                                <button type="button" class="btn nav-image-6" @click="dataArea('description')">
                                    <span class="blind">특이사항</span>
                                </button>
                            </li>
                        </ul>
                        <button
                            type="button"
                            class="btn nav-close"
                            @click="navCloseBtn(navClose == 'subnav-side-hide' ? '' : 'subnav-side-hide')"
                        >
                            <span class="blind">닫기</span>
                        </button>
                    </div>

                    <div class="subnav-side-box">
                        <!-- subnav-edit-box -->
                        <div class="subnav-edit-box" :class="dataType == 'base' ? 'on' : ''">
                            <div class="edit-form-wrapper">
                                <div class="field-box">
                                    <div class="label">
                                        STA
                                    </div>
                                    <div class="field">
                                        <input v-model="data.station" type="text" class="txt" readonly />
                                    </div>
                                </div>
                                <div class="field-box">
                                    <div class="label">
                                        Type
                                    </div>
                                    <div class="field">
                                        <input v-model="data.rockTypeName" type="text" class="txt" readonly />
                                    </div>
                                </div>
                                <div class="field-box">
                                    <div class="label">
                                        Date
                                    </div>
                                    <div class="field">
                                        <input v-model="data.investigationDay" type="text" class="txt" readonly />
                                    </div>
                                </div>
                                <div v-show="false" class="field-box">
                                    <div class="label">
                                        Time
                                    </div>
                                    <div class="field">
                                        <input v-model="data.investigationTime" type="text" class="txt" readonly />
                                    </div>
                                </div>
                                <div class="field-box">
                                    <div class="label">
                                        Jv
                                    </div>
                                    <div class="field">
                                        <input v-model="data.jvCount" type="text" class="txt" />
                                    </div>
                                </div>
                                <div class="field-box">
                                    <div class="label">
                                        RQD
                                    </div>
                                    <div class="field">
                                        {{ (115 - 3.3 * data.jvCount).toFixed(1) }}
                                    </div>
                                </div>
                            </div>

                            <div class="btn-wrapper pattern">
                                <button
                                    type="button"
                                    class="btn btn-delete"
                                    style="min-width: 60px;"
                                    @click="imageDelete()"
                                >
                                    <span>사진 삭제</span>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-upload"
                                    style="min-width: 60px;"
                                    @click="imageUpload()"
                                >
                                    <span>사진 선택</span>
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-upload"
                                    :style="originFileBtnCss"
                                    @click="imageOrigin()"
                                >
                                    <span>원본불러오기</span>
                                </button>
                            </div>
                        </div>
                        <!-- // subnav-edit-box -->

                        <!-- subnav-edit-box -->
                        <div class="subnav-edit-box" :class="dataType != 'base' ? 'on' : ''">
                            <!-- btn-list-wrapper -->
                            <div class="btn-list-wrapper">
                                <ul>
                                    <li style="width:100%;">
                                        <select v-model="selectedFace" @change="onChangedSelectedFace">
                                            <option value="FM" selected>
                                                막장면
                                            </option>
                                            <option value="GS">
                                                지질면
                                            </option>
                                        </select>
                                    </li>
                                </ul>
                                <ul>
                                    <li>
                                        <button
                                            type="button"
                                            class="btn btn-editor"
                                            :class="requestReset === true ? 'on' : ''"
                                            @click="doRequestAction('init')"
                                        >
                                            <span>초기화</span>
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            class="btn btn-editor"
                                            :class="requestUndo === true ? 'on' : ''"
                                            @click="doRequestAction('undo')"
                                        >
                                            <i class="undo" /><span>이전</span>
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            class="btn btn-editor"
                                            :class="requestRedo === true ? 'on' : ''"
                                            @click="doRequestAction('redo')"
                                        >
                                            <i class="redo" /><span>재실행</span>
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            class="btn btn-editor"
                                            :class="eraseEnable === true ? 'on' : ''"
                                            @click="enabledErase"
                                        >
                                            <i class="erase" /><span>지우개</span>
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            class="btn btn-editor"
                                            :class="zoomEnable === true ? 'on' : ''"
                                            @click="enabledZoom"
                                        >
                                            <i class="zoom_move" /><span>확대/이동 활성</span>
                                        </button>
                                    </li>
                                </ul>

                                <div class="maintance-selected">
                                    <label class="btn btn-editor">
                                        <input
                                            v-model="isKeepSelectedOperation"
                                            type="checkbox"
                                            class="chk"
                                            @change="changeKeepSelectedOperation"
                                        />
                                        <span>선택 객체 유지하기</span>
                                    </label>
                                </div>

                                <div
                                    class="title-sub"
                                    :class="isDrawFreeLineSelected() ? 'on' : ''"
                                    @click="drawFreeLine()"
                                >
                                    자유선 버튼
                                </div>

                                <div class="select-list-wrapper">
                                    <ul>
                                        <li style="width: 100%;">
                                            <select ref="freeLineSize" v-model="freeLineSize" style="width: 80px;">
                                                <option
                                                    v-for="(item, index) in lineSizeList"
                                                    :key="index"
                                                    :value="item"
                                                >
                                                    {{ item }} px
                                                </option>
                                            </select>
                                            <select ref="freeLineColor" v-model="freeLineColor" style="width: 120px;">
                                                <option
                                                    v-for="(item, index) in fontColorList"
                                                    :key="index"
                                                    :value="item"
                                                >
                                                    {{ item }}
                                                </option>
                                            </select>
                                        </li>
                                    </ul>
                                </div>

                                <div class="title-sub" :class="isDrawTextSelected() ? 'on' : ''" @click="drawText('')">
                                    텍스트 버튼
                                </div>

                                <div class="select-list-wrapper">
                                    <ul>
                                        <li style="width: 100%;">
                                            <select ref="fontSize" v-model="fontSize" style="width: 80px;">
                                                <option
                                                    v-for="(item, index) in fontSizeList"
                                                    :key="index"
                                                    :value="item"
                                                >
                                                    {{ item }} em
                                                </option>
                                            </select>
                                            <select ref="fontColor" v-model="fontColor" style="width: 120px;">
                                                <option
                                                    v-for="(item, index) in fontColorList"
                                                    :key="index"
                                                    :value="item"
                                                >
                                                    {{ item }}
                                                </option>
                                            </select>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!-- // btn-list-wrapper -->

                            <div class="edit-scroll-box">
                                <!-- edit-sel-box -->

                                <!-- [2024/06/22] deprecated -->
                                <!-- 
                                    <div class="edit-sel-box" :class="dataType == 'rockQuality' ? 'on' : ''">
                                        <div class="title-pattern">
                                            암질 그리기
                                        </div>
                                        <div class="draw-btn-wrapper">
                                            <ul>
                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#c9c9c9'
                                                                ? 'btn btn-draw-1 on'
                                                                : 'btn btn-draw-1'
                                                        "
                                                        @click="drawRockPolygon('#c9c9c9')"
                                                    >
                                                        <span>극경암</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#78a3de'
                                                                ? 'btn btn-draw-2 on'
                                                                : 'btn btn-draw-2'
                                                        "
                                                        @click="drawRockPolygon('#78a3de')"
                                                    >
                                                        <span>경암</span>
                                                    </button>
                                                </li>

                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#afa28b'
                                                                ? 'btn btn-draw-4 on'
                                                                : 'btn btn-draw-4'
                                                        "
                                                        @click="drawRockPolygon('#afa28b')"
                                                    >
                                                        <span>연암</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#96be80'
                                                                ? 'btn btn-draw-5 on'
                                                                : 'btn btn-draw-5'
                                                        "
                                                        @click="drawRockPolygon('#96be80')"
                                                    >
                                                        <span>풍화암</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#4aa9cc'
                                                                ? 'btn btn-draw-6 on'
                                                                : 'btn btn-draw-6'
                                                        "
                                                        @click="drawRockPolygon('#4aa9cc')"
                                                    >
                                                        <span>풍화잔류토</span>
                                                    </button>
                                                </li>

                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#c25b12'
                                                                ? 'btn btn-draw-8 on'
                                                                : 'btn btn-draw-8'
                                                        "
                                                        @click="drawRockPolygon('#c25b12')"
                                                    >
                                                        <span>단층대<br />파쇄대</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#faf99e'
                                                                ? 'btn btn-draw-3 on'
                                                                : 'btn btn-draw-3'
                                                        "
                                                        @click="drawRockPolygon('#faf99e')"
                                                    >
                                                        <span>보통암</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#f5ba72'
                                                                ? 'btn btn-draw-7 on'
                                                                : 'btn btn-draw-7'
                                                        "
                                                        @click="drawRockPolygon('#f5ba72')"
                                                    >
                                                        <span>층적층</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        :class="
                                                            selectedRockColor === '#fff'
                                                                ? 'btn btn-draw-9 on'
                                                                : 'btn btn-draw-9'
                                                        "
                                                        @click="drawRockPolygon('#fff')"
                                                    >
                                                        <span>NONE</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> 
                                -->
                                <!-- end of [2024/06/22] deprecated -->

                                <!-- // edit-sel-box -->

                                <div class="edit-sel-box" :class="dataType == 'jointCondition' ? 'on' : ''">
                                    <div class="title-pattern">
                                        절리 상태
                                    </div>
                                    <div class="draw-btn-wrapper">
                                        <ul>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '5mm미만 단단한 충전물'
                                                            ? 'btn btn-draw-1 on'
                                                            : 'btn btn-draw-1'
                                                    "
                                                    @click="drawText('5mm미만 단단한 충전물')"
                                                >
                                                    <span>5mm미만<br />단단한 충전물</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '5mm이상 단단한 충전물'
                                                            ? 'btn btn-draw-1 on'
                                                            : 'btn btn-draw-1'
                                                    "
                                                    @click="drawText('5mm이상 단단한 충전물')"
                                                >
                                                    <span>5mm이상<br />단단한 충전물</span>
                                                </button>
                                            </li>

                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '5mm미만 연약한 충전물'
                                                            ? 'btn btn-draw-1 on'
                                                            : 'btn btn-draw-1'
                                                    "
                                                    @click="drawText('5mm미만 연약한 충전물')"
                                                >
                                                    <span>5mm미만<br />연약한 충전물</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '5mm이상 연약한 충전물'
                                                            ? 'btn btn-draw-1 on'
                                                            : 'btn btn-draw-1'
                                                    "
                                                    @click="drawText('5mm이상 연약한 충전물')"
                                                >
                                                    <span>5mm이상<br />연약한 충전물</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '약간풍화'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('약간풍화')"
                                                >
                                                    <span>약간풍화</span>
                                                </button>
                                            </li>

                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '풍화'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('풍화')"
                                                >
                                                    <span>풍화</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '심한풍화'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('심한풍화')"
                                                >
                                                    <span>심한풍화</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '파쇄'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('파쇄')"
                                                >
                                                    <span>파쇄</span>
                                                </button>
                                            </li>

                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '매우거침'
                                                            ? 'btn btn-draw-4 on'
                                                            : 'btn btn-draw-4'
                                                    "
                                                    @click="drawText('매우거침')"
                                                >
                                                    <span>매우거침</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '거침'
                                                            ? 'btn btn-draw-4 on'
                                                            : 'btn btn-draw-4'
                                                    "
                                                    @click="drawText('거침')"
                                                >
                                                    <span>거침</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '약간거침'
                                                            ? 'btn btn-draw-4 on'
                                                            : 'btn btn-draw-4'
                                                    "
                                                    @click="drawText('약간거침')"
                                                >
                                                    <span>약간거침</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '매끄러움'
                                                            ? 'btn btn-draw-4 on'
                                                            : 'btn btn-draw-4'
                                                    "
                                                    @click="drawText('매끄러움')"
                                                >
                                                    <span>매끄러움</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- edit-sel-box -->
                                <div class="edit-sel-box" :class="dataType == 'joint' ? 'on' : ''">
                                    <div class="title-pattern">
                                        절리 그리기
                                    </div>
                                    <div class="edit-form-wrapper">
                                        <div class="field-box">
                                            <div class="label">
                                                Jv
                                            </div>
                                            <div class="field">
                                                <input v-model="data.jvCount" type="text" class="txt" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="draw-btn-wrapper">
                                        <ul>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointColor === 'black'
                                                            ? 'btn btn-jully-1 on'
                                                            : 'btn btn-jully-1'
                                                    "
                                                    @click="drawJointLine('black')"
                                                >
                                                    <span>Joint1</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointColor === 'red'
                                                            ? 'btn btn-jully-2 on'
                                                            : 'btn btn-jully-2'
                                                    "
                                                    @click="drawJointLine('red')"
                                                >
                                                    <span>Joint2</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointColor === 'blue'
                                                            ? 'btn btn-jully-3 on'
                                                            : 'btn btn-jully-3'
                                                    "
                                                    @click="drawJointLine('blue')"
                                                >
                                                    <span>Joint3</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointColor === 'green'
                                                            ? 'btn btn-jully-4 on'
                                                            : 'btn btn-jully-4'
                                                    "
                                                    @click="drawJointLine('green')"
                                                >
                                                    <span>Joint4</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointColor === 'gray'
                                                            ? 'btn btn-jully-5 on'
                                                            : 'btn btn-jully-5'
                                                    "
                                                    @click="drawJointLine('gray')"
                                                >
                                                    <span>Joint5</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- // edit-sel-box -->

                                <!-- edit-sel-box -->
                                <div class="edit-sel-box" :class="dataType == 'underWater' ? 'on' : ''">
                                    <div class="title-pattern">
                                        지하수 그리기
                                    </div>
                                    <div class="draw-btn-wrapper">
                                        <ul>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedWaterIcon === 'damp'
                                                            ? 'btn btn-jiha-1 on'
                                                            : 'btn btn-jiha-1'
                                                    "
                                                    @click="drawWaterIcon('damp')"
                                                >
                                                    <span class="blind">damp</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedWaterIcon === 'wet'
                                                            ? 'btn btn-jiha-2 on'
                                                            : 'btn btn-jiha-2'
                                                    "
                                                    @click="drawWaterIcon('wet')"
                                                >
                                                    <span class="blind">wet</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedWaterIcon === 'dripping'
                                                            ? 'btn btn-jiha-3 on'
                                                            : 'btn btn-jiha-3'
                                                    "
                                                    @click="drawWaterIcon('dripping')"
                                                >
                                                    <span class="blind">dripping</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedWaterIcon === 'flowing'
                                                            ? 'btn btn-jiha-4 on'
                                                            : 'btn btn-jiha-4'
                                                    "
                                                    @click="drawWaterIcon('flowing')"
                                                >
                                                    <span class="blind">flowing</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- // edit-sel-box -->

                                <!-- edit-sel-box -->
                                <div class="edit-sel-box" :class="dataType == 'rockType' ? 'on' : ''">
                                    <div class="title-pattern">
                                        암질 그리기
                                    </div>
                                    <div class="draw-btn-wrapper rock-list">
                                        <ul>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedTypePattern === 'pattern1'
                                                            ? 'btn btn-pattern-1 on'
                                                            : 'btn btn-pattern-1'
                                                    "
                                                    @click="drawTypePattern('pattern1')"
                                                >
                                                    <span>단층파쇄대</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedTypePattern === 'pattern2'
                                                            ? 'btn btn-pattern-2 on'
                                                            : 'btn btn-pattern-2'
                                                    "
                                                    @click="drawTypePattern('pattern2')"
                                                >
                                                    <span>경암</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedTypePattern === 'pattern3'
                                                            ? 'btn btn-pattern-3 on'
                                                            : 'btn btn-pattern-3'
                                                    "
                                                    @click="drawTypePattern('pattern3')"
                                                >
                                                    <span>연암</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedTypePattern === 'pattern4'
                                                            ? 'btn btn-pattern-4 on'
                                                            : 'btn btn-pattern-4'
                                                    "
                                                    @click="drawTypePattern('pattern4')"
                                                >
                                                    <span>풍화암</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedTypePattern === 'pattern5'
                                                            ? 'btn btn-pattern-5 on'
                                                            : 'btn btn-pattern-5'
                                                    "
                                                    @click="drawTypePattern('pattern5')"
                                                >
                                                    <span>풍화잔류토</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="draw-btn-wrapper">
                                        <ul>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '단층파쇄대'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('단층파쇄대')"
                                                >
                                                    <span>단층파쇄대</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '경암'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('경암')"
                                                >
                                                    <span>경암</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '연암'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('연암')"
                                                >
                                                    <span>연암</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '풍화암'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('풍화암')"
                                                >
                                                    <span>풍화암</span>
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    :class="
                                                        selectedJointCondition === '풍화잔류토'
                                                            ? 'btn btn-draw-3 on'
                                                            : 'btn btn-draw-3'
                                                    "
                                                    @click="drawText('풍화잔류토')"
                                                >
                                                    <span>풍화잔류토</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <!-- // edit-sel-box -->
                                <!-- edit-sel-box -->
                                <div class="edit-sel-box" :class="dataType == 'description' ? 'on' : ''">
                                    <div>
                                        <div class="title-pattern">
                                            특기사항
                                        </div>
                                        <div class="textarea-box">
                                            <textarea v-model="data.description" style="height: 200px;" />
                                        </div>
                                        <div class="title-pattern">
                                            굴착현황
                                        </div>
                                        <div class="textarea-box">
                                            <textarea v-model="data.faultShearZone" style="height: 200px;" />
                                        </div>
                                    </div>
                                </div>
                                <!-- // edit-sel-box -->
                            </div>
                            <!-- // subnav-edit-box -->
                            <!-- <div class="btn-wrapper-bottom">
                                <button type="button" class="btn btn-edit-cancel">
                                    <span>편집취소</span>
                                </button>
                                <button type="button" class="btn btn-edit-save">
                                    <span>편집저장</span>
                                </button>
                            </div> -->
                        </div>
                        <!-- // subnav-edit-box -->

                        <button
                            type="button"
                            class="btn nav-close"
                            @click="navCloseBtn(navClose == 'subnav-side-hide' ? '' : 'subnav-side-hide')"
                        >
                            <span class="blind">닫기</span>
                        </button>
                    </div>

                    <div class="right-image-box">
                        <div v-show="selectedFace === 'FM'" class="draw-top-img">
                            <p class="draw-title">
                                막장면
                            </p>
                            <div class="draw-inner">
                                <div class="draw-content2">
                                    <div class="background2">
                                        <div class="center-box">
                                            <div id="id-d3-fm-container" class="photo-box" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="selectedFace === 'GS'" class="draw-bot-img">
                            <p class="draw-title2">
                                지질면
                            </p>
                            <div class="draw-inner">
                                <div class="draw-content2">
                                    <div class="background2">
                                        <div class="center-box-for-gs">
                                            <div id="id-d3-gs-container" class="white-background" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="btn-wrapper bottom-fixed">
                        <button type="button" class="btn btn-cancel" @click="prev(data.tunnelConstructionMethod, 1)">
                            <span>이전으로</span>
                        </button>
                        <button type="button" class="btn btn-next" @click="saveAndNext()">
                            <span>저장 및 다음으로</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';
import { FILE_URL, PICTURE_SORCE_TYPE } from '../const';
import CameraHelper from '../helper/CameraHelper';
import { photoDialog } from '../helper/DialogHelper';
import gnb from './layout/gnb.vue';

/* [2021/03/27] added */
import FacemappingCanvas from '../helper/FacemappingCanvasHelper';
/* end of [2021/03/27] */

export default {
    name: 'Step2',
    components: {
        gnb
    },
    data: () => {
        return {
            id: null,
            dataType: 'base',
            navClose: '',
            gnbShow: '',
            data: {
                id: null,
                station: ''
            },
            frontImageUrl: null,
            frontImage: null,
            frontImageOriginUrl: null,
            frontImageOrigin: null,
            originFileBtnCss: 'min-width: 60px;background-color: #38b2c2',

            /* [2021/03/27] */
            facemappingCanvas: null,

            /* [2024/05/25] added */
            facemappingGSCanvas: null,
            /* end of [2024/05/25] */
            /* */
            zoomEnable: true,
            requestReset: false,
            requestUndo: false,
            requestRedo: false,
            eraseEnable: false,

            selectedRockColor: '',
            selectedJointColor: '',
            selectedWaterIcon: '',
            selectedTypePattern: '',
            drawTextEnable: false,
            isKeepSelectedOperation: false,

            freeLineSize: 2,
            freeLineColor: 'white',

            /* [2024/05/25] added */
            facemappingStatusBackup: null,
            facemappingGSStatusBackup: null,
            /* end of [2024/05/25] */

            /* [2024/06/22] added */
            fontSize: 0.5,
            fontColor: 'white',
            /* end of [2024/06/22] */

            /* */
            selectedFace: 'FM',
            lineSizeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30],
            fontSizeList: [0.5, 1, 1.5, 2, 3],
            fontColorList: ['white', 'yellow', 'red', 'blue', 'green', 'purple', 'black'],

            selectedJointCondition: ''
        };
    },
    computed: {
        ...mapState({
            stateData: state => {
                return JSON.parse(JSON.stringify(state.facemapping.data));
            }
        })
    },
    beforeCreate() {
        ///////////////////////
        // Initializer Area
        ///////////////////////
        //this.hideLoading();
    },
    created() {},
    mounted() {
        //ScreenHelper.setLandscape();
        this.id = this.$route.params.id;

        var that = this;

        /* [2021/03/27] */
        this.facemappingCanvas = FacemappingCanvas();
        this.facemappingCanvas.initCanvas(this.id, '#id-d3-fm-container');
        this.facemappingCanvas.enableKeepSelectedOperation(this.isKeepSelectedOperation);
        this.facemappingCanvas.setOnChangedZoomEnable(function(enabled) {
            that.zoomEnable = enabled;
        });
        this.facemappingCanvas.setOnChangedEraseEnable(function(enabled) {
            that.eraseEnable = enabled;
        });
        this.facemappingCanvas.setOnReleaseRequestOperation(function() {
            that.releaseSelectedModeAll();
        });
        /* end of [2021/03/27] */

        /* [2024/05/25] added */
        this.facemappingGSCanvas = FacemappingCanvas();
        /* [2024/06/17] added patternPrefix */
        this.facemappingGSCanvas.initCanvas(this.id, '#id-d3-gs-container', 'GS');
        /* only GS */
        this.facemappingGSCanvas.disableZoomForcibly();

        this.facemappingGSCanvas.enableKeepSelectedOperation(this.isKeepSelectedOperation);
        this.facemappingGSCanvas.setOnChangedZoomEnable(function(enabled) {
            that.zoomEnable = enabled;
        });
        this.facemappingGSCanvas.setOnChangedEraseEnable(function(enabled) {
            that.eraseEnable = enabled;
        });
        this.facemappingGSCanvas.setOnReleaseRequestOperation(function() {
            that.releaseSelectedModeAll();
        });
        /* end of [2024/05/25] */

        if (this.id !== null) {
            this.dataObj();
        }
        this.hideLoading();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading', 'alert']),
        backbtn() {
            this.$router.go(-1);
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        prev(tunnelConstructionMethod, step) {
            this.$router.push({ path: `/step` + step + `/${this.data.id}` });
        },
        nextStep(tunnelConstructionMethod, step) {
            if (step === 5) {
                this.$router.push({ path: `/step5/` + this.data.constructionName + `/${this.data.id}` });
            } else {
                this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            }
        },
        dataObj() {
            this.showLoading();

            /* [2024/05/25][UNDER CONSTRUCTION] */
            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;
                this.frontImageUrl = this.data.frontImageUrl !== null ? FILE_URL + this.data.frontImageUrl : null;
                this.frontImage = this.data.frontImage;
                this.frontImageOriginUrl = this.data.frontImageOriginUrl;
                this.frontImageOrigin = this.data.frontImageOrigin;

                if (this.data.frontImageOrigin === null) {
                    this.originFileBtnCss = 'min-width: 60px;background-color: #8f8f96';
                }

                console.log('[*] detail response:', this.data);

                /* [2021/03/27] */
                this.facemappingCanvas.initData(this.data, 'FM');
                this.facemappingGSCanvas.initData(this.data, 'GS');
                /* end of [2021/03/27] */

                this.hideLoading();
            });
        },
        saveAndNext() {
            this.showLoading();

            /* [2021/03/27] added & modified
             *
             * id
             * frontImage
             * frontImageOrigin
             * rockJudgmentImage
             * rockJudgmentObj
             * description
             * reinforcement
             * faultShearZone
             */
            try {
                var dumpDbAll = {};
                /* [2024/05/25] web 규격 */
                /*
                    {
                        version: VERSION,
                        // FM은 기존 필드 유지
                        joints: jointsForFM,
                        rocks: rocksForFM,
                        waters: watersForFM,
                        texts: textsForFM,var
                        types: typesForFM,
                        freelines: freelinesForFM,

                        // GS는 <field> + "4gs"
                        joints4gs: jointsForGS,
                        rocks4gs: rocksForGS,
                        waters4gs: watersForGS,
                        texts4gs: textsForGS,
                        types4gs: typesForGS,
                        freelines4gs: freelinesForGS,
                    }
                 */
                this.saveFacemappingImage_1st(dumpDbAll);
            } catch (e) {
                this.hideLoading();
            }
            // var that = this;
            // /* [2024/05/25][UNDER CONSTRUCTION] */
            // if (this.facemappingCanvas) {
            //     this.facemappingCanvas.saveImage(
            //         'FM',
            //         function(rockJudgmentObj, rockJudgmentImage) {
            //             that.data.rockJudgmentObj = rockJudgmentObj;
            //             that.data.rockJudgmentImage = rockJudgmentImage;
            //             that.data.frontImage = that.frontImage;
            //             /* */
            //             FacemappingApi.postImge(that.data).then(() => {
            //                 that.hideLoading();
            //                 that.$router.push({ path: `/step3/${that.data.id}` });
            //             });
            //         },
            //         function(e) {
            //             console.log(e);
            //             that.hideLoading();
            //         }
            //     );
            // }
            // /* end of [2021/03/27] */
        },
        /* [2024/05/25] added */
        saveFacemappingImage_1st(dumpDbAll) {
            try {
                var that = this;
                if (this.facemappingCanvas) {
                    this.facemappingCanvas.saveImage(
                        'FM',
                        function(rockJudgmentObj /* object */, rockJudgmentImage) {
                            /* for FM */
                            that.data.rockJudgmentImage = rockJudgmentImage;
                            that.data.frontImage = that.frontImage;

                            /* FM & GS 모두 concat */
                            /* FM은 기존 필드 유지 */
                            dumpDbAll = rockJudgmentObj;

                            console.log('[*] freelines', dumpDbAll.freelines);

                            /* */
                            that.saveFacemappingGSCutImage_2nd(dumpDbAll);
                        },
                        function(e) {
                            console.log(e);
                            that.hideLoading();
                        }
                    );
                }
            } catch (e) {
                that.hideLoading();
            }
        },
        saveFacemappingGSCutImage_2nd(dumpDbAll) {
            try {
                var that = this;
                if (this.facemappingGSCanvas) {
                    this.facemappingGSCanvas.saveImage(
                        'GS2',
                        function(rockJudgmentObj, threeDimensionalFile1) {
                            /* for GS */
                            that.data.threeDimensionalFile1 = threeDimensionalFile1;
                            that.saveFacemappingGSImage_2nd(dumpDbAll);
                        },
                        function(e) {
                            console.log(e);
                            that.hideLoading();
                        }
                    );
                }
            } catch (e) {
                that.hideLoading();
            }
        },
        saveFacemappingGSImage_2nd(dumpDbAll) {
            try {
                var that = this;
                if (this.facemappingGSCanvas) {
                    this.facemappingGSCanvas.saveImage(
                        'GS',
                        function(rockJudgmentObj /* object */, rockJudgmentImage) {
                            /* for GS */
                            that.data.rockProgressImage = rockJudgmentImage;

                            /* concat */
                            dumpDbAll.joints4gs = rockJudgmentObj.joints || [];
                            dumpDbAll.rocks4gs = rockJudgmentObj.rocks || [];
                            dumpDbAll.waters4gs = rockJudgmentObj.waters || [];
                            dumpDbAll.texts4gs = rockJudgmentObj.texts || [];
                            dumpDbAll.types4gs = rockJudgmentObj.types || [];
                            dumpDbAll.freelines4gs = rockJudgmentObj.freelines || [];

                            console.log('[*] freelines4gs', dumpDbAll.freelines4gs);

                            that.data.rockJudgmentObj = JSON.stringify(dumpDbAll);

                            console.log('[*] postImge params:', that.data);

                            /* upload data */
                            FacemappingApi.postImge(that.data).then(() => {
                                that.hideLoading();
                                that.$router.push({ path: `/step3/${that.data.id}` });
                            });
                        },
                        function(e) {
                            console.log(e);
                            that.hideLoading();
                        }
                    );
                }
            } catch (e) {
                that.hideLoading();
            }
        },

        /* end of [2024/05/25] */
        dataArea(type) {
            this.dataType = type;

            if (this.dataType === 'base') {
                /* [2024/05/25] added */
                if (this.selectedFace !== 'FM') {
                    this.selectedFace = 'FM';
                    this.restoreFacemappingState('FM');
                }
            }
        },

        /* [2021/03/27] added */
        doRequestAction(type) {
            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                if (type === 'init') {
                    this.requestReset = true;
                    canvas.reset();
                    this.requestReset = false;
                } else if (type === 'undo') {
                    this.requestUndo = true;
                    canvas.undo();
                    this.requestUndo = false;
                } else if (type === 'redo') {
                    this.requestRedo = true;
                    canvas.redo();
                    this.requestRedo = false;
                }
            }
        },
        enabledErase() {
            this.releaseSelectedModeAll();

            /* */
            this.eraseEnable = !this.eraseEnable;

            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.enableErase(this.eraseEnable);
            }
        },
        enabledZoom() {
            this.releaseSelectedModeAll();
            /* */
            this.zoomEnable = !this.zoomEnable;

            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.enableZoom(this.zoomEnable);
            }
        },
        changeKeepSelectedOperation() {
            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.enableKeepSelectedOperation(this.isKeepSelectedOperation);
            }
        },
        releaseSelectedModeAll() {
            this.selectedRockColor = '';
            this.selectedJointColor = '';
            this.selectedWaterIcon = '';
            this.selectedTypePattern = '';
            this.drawTextEnable = false;
        },
        drawJointLine(color) {
            this.releaseSelectedModeAll();
            /* */
            this.selectedJointColor = color;

            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.drawJointLine(this.selectedJointColor);
            }
        },
        drawRockPolygon(color) {
            this.releaseSelectedModeAll();
            /* */
            this.selectedRockColor = color;

            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.drawRockPolygon(this.selectedRockColor);
            }
        },
        drawWaterIcon(icon) {
            this.releaseSelectedModeAll();
            /* */
            this.selectedWaterIcon = icon;

            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.drawWaterIcon(this.selectedWaterIcon);
            }
        },
        drawText(autoText) {
            this.releaseSelectedModeAll();
            /* */
            this.drawTextEnable = true;

            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                this.selectedJointCondition = autoText;
                var fontSize = this.fontSize + 'em';
                var fontColor = this.fontColor;
                canvas.drawText(fontSize, fontColor, autoText);
            }
        },
        drawTypePattern(pattern) {
            this.releaseSelectedModeAll();
            /* */
            this.selectedTypePattern = pattern;

            /* [2024/05/25] modified */
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.drawTypePatternPolygon(this.selectedTypePattern);
            }
        },
        /* end of [2021/03/27] */

        navCloseBtn(status) {
            this.navClose = status;
        },
        imageUpload() {
            //  this.uploadFileIdx = idx; //현재 이미지 위치
            photoDialog(this.btnCamera, this.btnGallery);
            //  this.$router.push(`/photoEditor/${idx}`);
        },
        imageOrigin() {
            /* [2024/05/25] 막장면에 한정된 기능 */
            if (this.frontImageOrigin === null) {
                // var param = {};
                // param.isShow = true;
                // param.msg = '불러올 이미지가 없습니다.';
                // this.alert(param);
                return;
            }
            this.frontImageUrl = FILE_URL + this.frontImageOriginUrl;
            this.frontImage = this.frontImageOrigin;

            /* [2021/03/27] */
            if (this.facemappingCanvas) {
                this.facemappingCanvas.setFrontImageUrl(this.frontImageUrl);
                /* */
                console.log('[*] set front image url:' + this.frontImageUrl);
            }
            /* end of [2021/03/27] */
        },
        imageDelete() {
            /* [2024/05/25] 막장면에 한정된 기능 */
            this.frontImageUrl = null;
            this.frontImage = null;

            /* [2021/03/27] */
            if (this.facemappingCanvas) {
                this.facemappingCanvas.fileDelete();

                /* */
                console.log('[*] file delete');
            }
            /* end of [2021/03/27] */
        },
        btnCamera() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.CAMERA, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        btnGallery() {
            CameraHelper.getPicture(PICTURE_SORCE_TYPE.PHOTOLIBRARY, this.cameraImage, err => {
                console.log('fail:' + err);
            });
        },
        cameraImage(fileUrl) {
            /* [2024/05/25] 막장면에 한정된 기능 */
            const formData = new FormData();
            const now = new Date();
            const imageName = now.getTime() + '.jpg';

            this.frontImageUrl = fileUrl;

            formData.append('imgFile', CameraHelper.base64ToBlob(fileUrl), imageName);
            formData.append('file_id', '');
            this.showLoading();
            var that = this;
            FileApi.imgUpload(formData).then(result => {
                that.frontImage = result.content.fileId;
                console.log('that.frontImageL::::', that.frontImage);
                /* [2021/03/27] */
                if (that.facemappingCanvas) {
                    that.facemappingCanvas.setFrontImageUrl(
                        FILE_URL + '/api/file/download/image?file_id=' + result.content.fileId
                    );
                    //  that.facemappingCanvas.setFrontImageUrl(that.frontImageUrl);
                }
                /* end of [2021/03/27] */

                this.hideLoading();
            });
        },

        /* [2024/05/25] added */
        currentFacemappingCanvas() {
            if (this.selectedFace === 'GS') {
                if (this.facemappingGSCanvas) {
                    return this.facemappingGSCanvas;
                }
            } else {
                /* default: FM */
                if (this.facemappingCanvas) {
                    return this.facemappingCanvas;
                }
            }
            return null;
        },
        onChangedSelectedFace() {
            console.log('[*] on changed selectedFace:' + this.selectedFace);
            this.restoreFacemappingState(this.selectedFace);
            if (this.selectedFace === 'GS') {
                this.freeLineColor = 'black';
                this.fontColor = 'black';
            } else {
                this.freeLineColor = 'white';
                this.fontColor = 'white';
            }
        },
        restoreFacemappingState(selectedFace) {
            console.log('[*] switching to "' + selectedFace + '" facemapping');

            var current = {
                zoomEnable: this.zoomEnable,
                requestReset: this.requestReset,
                requestUndo: this.requestUndo,
                requestRedo: this.requestRedo,
                eraseEnable: this.eraseEnable,

                selectedRockColor: this.selectedRockColor,
                selectedJointColor: this.selectedJointColor,
                selectedWaterIcon: this.selectedWaterIcon,
                selectedTypePattern: this.selectedTypePattern,
                drawTextEnable: this.drawTextEnable,
                isKeepSelectedOperation: this.isKeepSelectedOperation,

                freeLineSize: this.freeLineSize,
                freeLineColor: this.freeLineColor
            };
            var restore = null;
            if (selectedFace === 'GS') {
                restore = this.facemappingGSStatusBackup;
                this.facemappingStatusBackup = current;
            } else {
                restore = this.facemappingStatusBackup;
                this.facemappingGSStatusBackup = current;
            }

            if (restore) {
                this.zoomEnable = restore.zoomEnable;
                this.requestReset = restore.requestReset;
                this.requestUndo = restore.requestUndo;
                this.requestRedo = restore.requestRedo;
                this.eraseEnable = restore.eraseEnable;

                this.selectedRockColor = restore.selectedRockColor;
                this.selectedJointColor = restore.selectedJointColor;
                this.selectedWaterIcon = restore.selectedWaterIcon;
                this.selectedTypePattern = restore.selectedTypePattern;
                this.drawTextEnable = restore.drawTextEnable;
                this.isKeepSelectedOperation = restore.isKeepSelectedOperation;

                this.freeLineSize = restore.freeLineSize;
                this.freeLineColor = restore.freeLineColor;
            }
        },
        drawFreeLine() {
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                canvas.drawFreeLine(this.freeLineSize, this.freeLineColor);
            }
        },
        isDrawFreeLineSelected() {
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                return canvas.isDrawFreeLineSelected();
            }
            return false;
        },
        isDrawTextSelected() {
            var canvas = this.currentFacemappingCanvas();
            if (canvas) {
                return canvas.isDrawTextSelected();
            }
            return false;
        }
    }
};
</script>
